import { render, staticRenderFns } from "./TabletBulkUploadScreen.vue?vue&type=template&id=a4261e78&scoped=true&lang=pug"
import script from "./TabletBulkUploadScreen.vue?vue&type=script&lang=ts"
export * from "./TabletBulkUploadScreen.vue?vue&type=script&lang=ts"
import style0 from "./TabletBulkUploadScreen.vue?vue&type=style&index=0&id=a4261e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4261e78",
  null
  
)

export default component.exports